import styled from 'styled-components';

const ClaroDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    margin: 0 auto;
    padding: 0rem 0rem 0rem 0rem;
    max-width: 100%;
    align-items: center;
    justify-content: center;
`

export default ClaroDiv;